"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.navigate = exports.gHistory = void 0;

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/for-each"));

var createHistory = function createHistory() {
  var listeners = [];
  return {
    listen: function listen(listener) {
      listeners.push(listener);
      window.addEventListener('popstate', function () {
        listener();
      });
    },
    navigate: function navigate(to) {
      window.history.pushState({}, null, to);
      (0, _forEach.default)(listeners).call(listeners, function (listener) {
        return listener();
      });
    }
  };
};

var gHistory = createHistory();
exports.gHistory = gHistory;
var navigate = gHistory.navigate;
exports.navigate = navigate;